import { makeMetricListItem } from '../MetricListItem';

export const SiteReadingCardMetricListItem = makeMetricListItem(
    (value) => value.channelName,
    (value) => value.deviceName
);
